import { Component, HostListener, inject, signal } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { LanguageService, UILanguage } from './language.service';

type Dictionary = {
  [key: string]: {
    en: string;
    nl: string;
    fr: string;
  };
};

const DICTIONARY: Dictionary = {
  domain: { en: 'bgimports.be', nl: 'bgimports.be', fr: 'bgimports.be' },
  heroTitle: {
    en: 'Commercial Products',
    nl: 'Commerciele Producten',
    fr: 'Produits Commerciaux',
  },
  heroLead: {
    en: 'Browse the public catalog. Open one product to view all media and details.',
    nl: 'Bekijk de publieke catalogus. Open een product om alle media en details te zien.',
    fr: 'Parcourez le catalogue public. Ouvrez un produit pour voir tous les medias et details.',
  },
  signIn: { en: 'Sign In', nl: 'Inloggen', fr: 'Connexion' },
  contactPricing: {
    en: 'Contact Us for Pricing',
    nl: 'Contacteer ons voor prijzen',
    fr: 'Contactez-nous pour les prix',
  },
  signUp: { en: 'Sign Up', nl: 'Registreren', fr: 'Inscription' },
  language: { en: 'Language', nl: 'Taal', fr: 'Langue' },
  companyInfo: { en: 'Company Information', nl: 'Bedrijfsgegevens', fr: 'Informations de l entreprise' },
  vatLabel: { en: 'VAT', nl: 'BTW-nr.', fr: 'TVA' },
  addressLabel: { en: 'Address', nl: 'Adres', fr: 'Adresse' },
  phoneLabel: { en: 'Phone', nl: 'Telefoon', fr: 'Telephone' },
  emailLabel: { en: 'Email', nl: 'E-mail', fr: 'E-mail' },
};

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, RouterLink],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  private readonly languageService = inject(LanguageService);
  private readonly router = inject(Router);
  public language = this.languageService.language;
  public readonly languageMenuOpen = signal(false);
  public readonly companyName = 'Superlinkeroever BV';
  public readonly vatNumber = 'BE0752741576';
  public readonly address = 'Blancefloerlaan 75, 2050 Antwerpen, Belgium';
  public readonly phoneHref = '+32470845847';
  public readonly phoneDisplay = '0470 845847';
  public readonly email = 'hello@bgimport.be';

  public t(key: keyof typeof DICTIONARY): string {
    return DICTIONARY[key][this.language()] || DICTIONARY[key].en;
  }

  public setLanguage(next: UILanguage): void {
    this.languageService.setLanguage(next);
    this.languageMenuOpen.set(false);
  }

  public toggleLanguageMenu(): void {
    this.languageMenuOpen.update((open) => !open);
  }

  public isMobileRoute(): boolean {
    return this.router.url.startsWith('/mobile/');
  }

  @HostListener('document:click')
  public closeLanguageMenu(): void {
    this.languageMenuOpen.set(false);
  }

  @HostListener('document:keydown.escape')
  public closeLanguageMenuOnEscape(): void {
    this.languageMenuOpen.set(false);
  }
}
